import React from 'react';
import SquareCard from '../ui/SquareCard';
import { cn } from '../../lib/utils';

/**
 * SummarySection - Clean dark background summary cards
 * Shows key metrics in uniform square format
 */
const SummarySection = ({ title, subtitle, metrics, className }) => {
  return (
    <div className={cn(
      'bg-gradient-to-br from-gray-900 via-gray-850 to-black',
      'rounded-xl p-4 mb-4 border border-gray-800',
      className
    )}>
      {/* Section Header - Compact */}
      {(title || subtitle) && (
        <div className="mb-4">
          {title && (
            <h2 className="text-base font-semibold text-white">{title}</h2>
          )}
          {subtitle && (
            <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>
          )}
        </div>
      )}

      {/* Square Metric Cards Grid - Uniform sizing */}
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {metrics.map((metric, index) => (
          <SquareCard
            key={index}
            variant="summary"
            size="md"
            title={metric.label}
            value={metric.value}
            subtitle={metric.subtitle}
            icon={metric.icon}
            trend={metric.trend}
            trendDirection={metric.trendDirection}
            onClick={metric.onClick}
          />
        ))}
      </div>
    </div>
  );
};

export default SummarySection;
